import type { Amount } from '@shared/core-types';

const DECIMAL_BASE = 10;

export const alignAmountsPrecision = (amounts: Amount[]): Amount[] => {
    const precision = Math.max(...amounts.map((amount) => amount.precision));
    return amounts.map((amount): Amount => {
        const value = amount.value * DECIMAL_BASE ** (precision - amount.precision);
        return { ...amount, precision, value };
    });
};
